import React, {useRef, useEffect} from 'react'
import './cart.css'

function Cart({setOpenCart, open, cart, updateCartQty, removeFromCart}) {

    const cartRef = useRef(null)

    useEffect(() => {
        let handler = (e) => {
            if(!cartRef.current.contains(e.target)) {
                setOpenCart(false)
            }
        }
    
        document.addEventListener('mousedown', handler)
    
        return () => {
            document.removeEventListener('mousedown', handler)
        }
    }, [setOpenCart])  

    if(cart.line_items == null || cart.line_items === 'undefined') {
        return 'Loading...'
    }

    const EmptyCart = () => (
        <p className='serif'>No item in your bag.</p>
    ) 

    const FullCart = () => (
        cart.line_items.map(item => (
            <div key={item.id} className="cart-box">
                <div className="cart-img">
                    <img  src={item.image.url} alt="" />
                </div>
                <div className="cart-box-text-details">
                    <p style={{"textTransform": "uppercase"}} className='serif'>{item.name}</p>
                    <div className="cart-item-quantity">
                        <button className={`btn remove-btn serif ${item.quantity > 1 ? "" : "unclickabel"}`} onClick={() => updateCartQty(item.id, item.quantity - 1)}>-</button>
                        <p className='size'>Quantity: <span>{item.quantity}</span></p>
                        <button className='btn remove-btn serif' onClick={() => updateCartQty(item.id, item.quantity + 1)}>+</button>
                    </div>
                    {/* <p className='size'>Size: <span className='serif'>{0}</span></p> */}
                    <p>Price: <span className='serif'>{item.price.formatted_with_symbol}</span></p>
                </div>
                <button onClick={() => removeFromCart(item.id)} className='btn remove-btn serif'>Remove</button>
            </div>
        ))
    )

    return (
        <div ref={cartRef} className={`cart-container transition-width-all ${open}`}>
            <div className="cart-header">
                <h2 className="serif">
                    Shopping Cart
                </h2>
                <button onClick={() => setOpenCart(false)} className="btn link-close serif nav-link">-Close</button>
            </div>
            <div className="cart-body">
                {!cart.line_items.length ? <EmptyCart /> : <FullCart />}
            </div>
            {cart.line_items.length ? <div className="cart-footer">
                <div className="subtotal">
                    <p><span className='serif'>Total:</span> {cart.subtotal.formatted_with_symbol}</p>
                </div>
                <button className="btn link-proceed serif nav-link">Checkout</button>
            </div> : null}
        </div>
    )
}

export default Cart